import Extension from "../base/extension";

function parseOptions(node) {
  try {
    return JSON.parse(node.textContent || "{}");
  } catch {
    return null;
  }
}

function getMediaIndex(slide) {
  const idx = parseInt(
    slide.dataset.mediaIndex ?? slide.dataset.index ?? slide.dataset.swiperSlideIndex,
    10
  );
  return Number.isFinite(idx) ? idx : 0;
}

function shouldIgnorePhotoSwipeTarget(slide) {
  return (
    "pswpIgnore" in slide.dataset ||
    slide.classList.contains("product-media-slide--video")
  );
}

function findPhotoSwipeTarget(container, eventTarget) {
  const imageSlide = eventTarget.closest(".product-media-slide--image");
  if (imageSlide && container.contains(imageSlide)) return imageSlide;

  const slide = eventTarget.closest(".swiper-slide");
  if (slide && container.contains(slide)) return slide;

  return null;
}

async function openPhotoSwipe(baseOptions, slide) {
  const PhotoSwipe = await window.Stencil.ensureVendor("photoswipe");
  const pswp = new PhotoSwipe({ ...baseOptions, index: getMediaIndex(slide) });
  pswp.init();
}

class ProductPhotoswipe extends Extension {
  name = "ProductPhotoswipe";
  static autoregister = true;

  #mountedSections = new Set();

  async init() {
    // No-op unless the JSON payload exists on the page
    const payloads = document.querySelectorAll("script[data-pswp-datasource]");
    if (!payloads.length) return;

    payloads.forEach(async (payload) => {
      const sectionId = payload.getAttribute("data-section-id");
      if (!sectionId) return;
      if (this.#mountedSections.has(sectionId)) return;

      const container = document.querySelector(`#product-media-${sectionId}-full`);
      if (!container) return;

      const options = parseOptions(payload);
      if (!options?.dataSource?.length) return;

      container.addEventListener("click", async (e) => {
        const target = findPhotoSwipeTarget(container, e.target);
        if (!target) return;
        if (shouldIgnorePhotoSwipeTarget(target)) return;

        e.preventDefault();
        await openPhotoSwipe(options, target);
      });

      this.#mountedSections.add(sectionId);
    });
  }
}

export default ProductPhotoswipe;